// extracted by mini-css-extract-plugin
module.exports = {"tabSlider":"tabSlider__2vKfM"};